"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DataUnknownIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.837 15.184c-4.14-.241-7.32-1.55-7.405-3.14l-.001-2.113h.006c.022-.202.1-.398.229-.588.915 1.347 4.395 2.35 8.55 2.35.135 0 .269-.002.403-.004a6.483 6.483 0 00-1.782 3.495zm1.513 5.336h-.135c-4.804 0-8.707-1.423-8.783-3.19l-.001-2.114h.006c.022-.201.1-.398.229-.587.808 1.189 3.615 2.11 7.12 2.308a6.473 6.473 0 001.564 3.583z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.992 4.628H20v2.19c0 1.784-3.933 3.23-8.785 3.23-4.851 0-8.784-1.446-8.784-3.23v-2.19h.008c.203-1.624 4.055-2.92 8.776-2.92 4.722 0 8.574 1.296 8.777 2.92z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.25 21.5a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm.61-3.37c-.007-.388.026-.657.098-.808.072-.15.256-.349.554-.596.575-.479.95-.856 1.126-1.134.176-.277.263-.572.263-.883 0-.561-.239-1.054-.717-1.477-.478-.423-1.122-.634-1.93-.634-.77 0-1.391.209-1.864.627-.473.418-.728.926-.765 1.524l1.294.161c.09-.418.256-.729.497-.933.24-.204.54-.306.897-.306.371 0 .667.098.886.294.219.195.328.43.328.704a.878.878 0 01-.186.542c-.08.104-.326.323-.737.657s-.685.635-.822.903c-.137.267-.206.608-.206 1.023l.005.336h1.279zm-1.295 2.17h1.41V19h-1.41v1.3z"
  })));
});
DataUnknownIcon.category = 'Content';
var _default = DataUnknownIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/DataUnknownIcon.js
// module id = 1069
// module chunks = 0